// src/proctoring/nivelTest/NivelTestProctorPanel.jsx
import React from "react";

export default function NivelTestProctorPanel({
  proctor,
  deviceOpts,
  videoRef,
  onRetry,
  onSelectCam,
  selectedCamId,
  compact = false,
  switchingCamera = false,
}) {
  return (
    <div className={`ntp-card ${compact ? "ntp-card--compact" : ""}`}>
      <div className="ntp-head">
        <b>Vigilancia</b>
        <span className={`ntp-badge ${proctor?.blocked ? "bad" : "ok"}`}>
          {proctor?.blocked ? "Bloqueado" : "OK"}
        </span>
      </div>

      <video ref={videoRef} className="ntp-video" muted playsInline autoPlay />

      <div className="ntp-controls">
        <label className="ntp-label">
          Cámara
          <select
            className="ntp-select"
            value={selectedCamId ?? ""}
            onChange={(e) => onSelectCam?.(e.target.value || "")}
            disabled={switchingCamera}
          >
            <option value="">Automática (predeterminada)</option>
            {(deviceOpts?.cams || []).map((d) => (
              <option key={d.deviceId} value={d.deviceId}>
                {d.label || "Cámara"}
              </option>
            ))}
          </select>
        </label>

        <button
          className="ntp-btn"
          onClick={onRetry}
          type="button"
          disabled={switchingCamera}
        >
          {switchingCamera ? "Cambiando cámara..." : "Reintentar cámara"}
        </button>
      </div>

      {proctor?.blocked && (
        <div className="ntp-warn">
          <div><b>Activa la cámara para continuar.</b></div>
          {proctor?.reason ? (
            <div className="ntp-muted">Motivo: {proctor.reason}</div>
          ) : null}
        </div>
      )}
    </div>
  );
}